// extracted by mini-css-extract-plugin
export var cardLayout = "_8o-1";
export var paginationContainer = "_8o-0";